// extracted by mini-css-extract-plugin
export default {"wrapper":"Tips_style_wrapper__ERBZB","image":"Tips_style_image__HLuOq","dots":"Tips_style_dots__VBr4-","active":"Tips_style_active__gswgC","rotate":"Tips_style_rotate__07R2i"};